import "./enlacesInformativos.css";

const Faqs = () => {
  return (
    <div className="mx-auto border-0 w-[100%] md:w-[80%] min-h-screen py-[30px]" >
      <h1>Centro de Ayuda</h1>

      <section>
        <h2>Preguntas Frecuentes (FAQ)</h2>
        <h3>Reservas y Pagos</h3>
        <p>
          <strong>¿Cómo realizo una reserva?</strong>
        </p>
        <ul>
          <li>Busca la opción que mejor se adapte a tu viaje.</li>
          <li>
            Contacta al anfitrión a través de la plataforma para confirmar
            disponibilidad.
          </li>
          <li>Realiza el pago según las condiciones del anfitrión.</li>
          <li>Recibirás una confirmación con los detalles de tu estadía.</li>
        </ul>
        <p>
          <strong>¿Qué métodos de pago están disponibles?</strong>
        </p>
        <p>
          Los métodos de pago dependen de cada anfitrión. Algunos aceptan
          transferencias bancarias, billeteras virtuales o pagos en efectivo al
          llegar.
        </p>
        <p>
          <strong>¿Puedo cancelar o modificar mi reserva?</strong>
        </p>
        <p>
          Las cancelaciones y modificaciones dependen de la política de cada
          anfitrión.
        </p>
        <p>
          <strong>¿Recibo una confirmación después de pagar?</strong>
        </p>
        <p>Sí, recibirás un comprobante con los detalles de tu estadía.</p>
      </section>

      <section>
        <h2>Políticas y Responsabilidad</h2>
        <p>
          <strong>
            ¿La plataforma garantiza la disponibilidad del alojamiento?
          </strong>
        </p>
        <p>
          No. La plataforma facilita el contacto entre viajeros y anfitriones,
          pero no administra directamente los alojamientos.
        </p>
        <p>
          <strong>
            ¿Qué hacer si el alojamiento no cumple con lo prometido?
          </strong>
        </p>
        <ul>
          <li>Contactar al anfitrión para resolver la situación.</li>
          <li>
            Si no hay respuesta, infórmanos mediante el formulario de contacto.
          </li>
        </ul>
        <p>
          <strong>¿Cuáles son las políticas de cancelación?</strong>
        </p>
        <p>
          Cada anfitrión establece sus propias políticas de cancelación.
          Verifica los términos antes de reservar.
        </p>
      </section>

      <section>
        <h2>Estancia y Experiencia del Viajero</h2>
        <p>
          <strong>¿Qué pasa si tengo un problema durante mi estadía?</strong>
        </p>
        <ul>
          <li>Comunícate primero con el anfitrión.</li>
          <li>Si no hay respuesta, puedes reportarlo en la plataforma.</li>
        </ul>
        <p>
          <strong>¿Los alojamientos son pet friendly?</strong>
        </p>
        <p>
          Algunos alojamientos aceptan mascotas. Revisa la descripción o
          consulta con el anfitrión.
        </p>
      </section>

      <section>
        <h2>Anfitriones y Publicación de Alojamientos</h2>
        <p>
          <strong>¿Cómo publico mi alojamiento?</strong>
        </p>
        <ul>
          <li>Regístrate y completa tu perfil.</li>
          <li>Sube fotos y una descripción detallada.</li>
          <li>Define precios, condiciones y políticas.</li>
          <li>Una vez aprobado, estará disponible para reservas.</li>
        </ul>
        <p>
          <strong>¿Cuáles son los requisitos para ser anfitrión?</strong>
        </p>
        <ul>
          <li>Tener un alojamiento en condiciones.</li>
          <li>Proporcionar información clara y actualizada.</li>
          <li>Brindar atención rápida a los viajeros.</li>
        </ul>
      </section>

      <section>
        <h2>Contacto y Soporte</h2>
        <p>Puedes contactarnos a través de:</p>
        <ul>
          <li>Chat automático: Respuestas rápidas.</li>
          <li>Formulario de contacto: Para problemas técnicos o consultas.</li>
          <li>WhatsApp o email: Solo para soporte técnico.</li>
        </ul>
      </section>

      <section>
        <h2>Políticas y Términos de Uso</h2>
        <ul>
          <li>La plataforma solo conecta anfitriones y viajeros.</li>
          <li>Cada anfitrión es responsable de cumplir con lo publicado.</li>
          <li>
            Las cancelaciones y reembolsos deben resolverse con el anfitrión.
          </li>
        </ul>
      </section>
    </div>
  );
};

export default Faqs;
